module.exports = __webpack_public_path__ + "img/28.e48abe61.jpg";